// Angular 
import '@angular/core';
import "@angular/platform-browser";
import "@angular/platform-browser-dynamic";
import "@angular/forms";
import "@angular/http";
import '@angular/common';

// rxjs
import 'rxjs/Rx';
// Statics
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/timer';
import 'rxjs/add/observable/interval';
// Operators
import 'rxjs/add/operator/expand';
import 'rxjs/add/operator/concatMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/finally'; 
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/timeout';

import './css/styles.css';
import './css/theme-2.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';

//mdl
//import './css/material.light_blue-blue.min.css';
//import './css/icon.css';

//Images
import '../libs/images/loginIcon.png';
import '../libs/images/map_background.jpg';
import '../libs/images/loader.gif';
import '../libs/images/administratorSettings.svg';
import '../libs/images/accountInfo.svg';
import '../libs/images/home.svg';
import '../libs/images/signOut.svg';
import '../libs/images/somewhereElse.svg';
import '../libs/images/next.svg';
import '../libs/images/edit.svg';
import '../libs/images/noEdit.svg';
import '../libs/images/RamsImg.png';
import '../libs/images/SMC.png';
import '../libs/images/AMS.png';
import '../libs/images/rslapppage.png';
import '../libs/images/ecam.jpg';

//Resize sensor
import 'css-element-queries/src/ResizeSensor.js';

//jQuery
import 'jquery/dist/jquery.js';
import '../libs/etc/jquery-ui.js';

//jqGrid
import '../libs/jqgrid/src/i18n/grid.locale-en.js';
import '../libs/jqgrid/src/jquery.jqGrid.js';
import '../libs/jqgrid/css/ui.jqgrid.css';
import '../libs/jqGrid/src/jquery-1.11.0.min.js';

//jQuery multiselect
import 'jquery-ui-multiselect-widget/jquery.multiselect.css';
import 'jquery-ui-multiselect-widget/src/jquery.multiselect.min.js';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/vendor.ts